import { timeZone } from 'interfaces/timezone-type';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'stores/rematch/root-store';
import { TimezoneSelectorMode } from 'utilities/enum-utils';
import { usePortalUser } from 'utilities/react-hooks/use-portal-user';

export function useDisplayTimezone() {
  const portalUser = usePortalUser();
  const [displayTimezone, setDisplayTimezone] = useState<timeZone | null | undefined>(portalUser?.timezone as timeZone);
  const bookingDisplayTzMode = useSelector((state: IRootState) => state.bookingsStore.bookingDisplayTzMode);
  const bookingDisplayTzCustom = useSelector((state: IRootState) => state.bookingsStore.bookingDisplayTzCustom);

  const calculateTimezone = useCallback(() => {
    if (bookingDisplayTzMode === TimezoneSelectorMode.MyTimezone) {
      return portalUser?.timezone;
    }

    if (bookingDisplayTzMode === TimezoneSelectorMode.BookingTimezone) {
      return null;
    }

    if (bookingDisplayTzMode === TimezoneSelectorMode.CustomTimezone && bookingDisplayTzCustom) {
      return bookingDisplayTzCustom;
    }

    return displayTimezone;
  }, [bookingDisplayTzMode, bookingDisplayTzCustom, portalUser?.timezone, displayTimezone]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: run only on mount
  useEffect(() => {
    setDisplayTimezone(calculateTimezone());
    // should also run on closure of booking modal!
  }, []);

  return [displayTimezone, setDisplayTimezone] as const;
}
